'use strict';

const { ACTIVE_CLASS, SELECTED_CLASS } = require('../constants');
const { queryFirst, addClass, hasClass } = require('../domUtil');

/**
 * Resets Swiper instance in modal dialog to the first slide
 * Used when tabs or color swatches change content dynamically
 */
function resetSwiperInModal(dialogEl) {
    let targetPanel = queryFirst('.js-tab-panel.active', dialogEl);

    if (!targetPanel) {
        targetPanel = queryFirst('.js-single', dialogEl); // no-tabs case
    }

    if (!targetPanel) return;

    const slider = queryFirst('.js-swiper', targetPanel);
    const { swiper } = slider || {};

    if (swiper && swiper.activeIndex !== 0) {
        const $spinner = $(dialogEl).find('.image-container:visible').spinner();

        $spinner.start();
        swiper.slideTo(0, 0);
        $spinner.stop();
    }
}

/**
 * Scrolls active sheet-page to top
 * @param {Object} component - html sheet
 */
function scrollSheetTop($sheet) {
    const $active = $sheet.find('.sheet-page:visible').first();

    $active.find('.sheet-body-content').scrollTop(0);
}

/**
 * Resets active page to the first page and scrolls to top
 */
function resetModalSheet($modal) {
    const $sheet = $modal.find('.sheet');

    $modal.find('.sheet-page').removeClass(ACTIVE_CLASS);
    requestAnimationFrame(() => scrollSheetTop($sheet));
}

/**
 * Activates tab
 */
function activateTab($clickedTab) {
    const targetPanelId = $clickedTab.attr('aria-controls');
    const $sheet = $clickedTab.closest('.sheet');
    const targetPanel = document.getElementById(targetPanelId);

    if (!hasClass(targetPanel, ACTIVE_CLASS)) {
        $sheet.find('.js-tab-controls button')
            .removeClass(ACTIVE_CLASS)
            .attr('aria-selected', 'false')
            .attr('tabindex', '-1');

        $sheet.find('.js-tab-panel').removeClass(ACTIVE_CLASS);

        $clickedTab
            .addClass(ACTIVE_CLASS)
            .attr('aria-selected', 'true')
            .attr('tabindex', '0');

        addClass(targetPanel, ACTIVE_CLASS);
        requestAnimationFrame(() => {
            scrollSheetTop($sheet);
        });

        // update opener for next modal usage:
        const $updatedTrigger = $(`.js-stylitics-look-trigger[data-index="${$clickedTab.data('index')}"`);
        if ($updatedTrigger) {
            $sheet.data('opener', $updatedTrigger);
        }
    }

    // if tab has color swatches, reset to the first color:
    const $firstSwatch = $(targetPanel).find('.js-tile-swatch').first();
    if (!$firstSwatch.hasClass(SELECTED_CLASS)) {
        $firstSwatch.click();
    } else {
        const dialogEl = targetPanel.closest('.sheet-body');
        resetSwiperInModal(dialogEl);
    }

    // used by components to send analytics when tab is displayed:
    const tabEvent = new CustomEvent('tabActivated', {
        detail: { tabActive: targetPanel },
        bubbles: true,
        cancelable: false
    });

    targetPanel.dispatchEvent(tabEvent);

    requestAnimationFrame(() => {
        $clickedTab.focus();
    });
}

module.exports = {
    resetSwiperInModal,
    scrollSheetTop,
    activateTab,
    resetModalSheet
};
